import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { formatAmount } from "../../common/StyledComponents/StyledFields";
import FrontDeskIncomeReportGridTable from "./frontDeskIncomeReportGridTable";

const FrontDeskIncomeReportTableData = (props: any) => {
    const [itemAddedData,setItemAddedData] = useState<any[]>([])
    useEffect(() => {
      const uniqueEntries = new Set<any>();
      props.ReportData.forEach((item: any) => {
        Object.entries(item).forEach(([key, value]: any) => { 
          if (Array.isArray(value)) {
            value.forEach((obj: any) => {
              uniqueEntries.add({ Title: obj.title, Amount: formatAmount(obj.amount ),typeId:obj.typeid,link:obj.typeid ? true : false});
            });
          } else {
            uniqueEntries.add({ Title: key, Amount: formatAmount(value),link:false });
          }
        });
      });
      setItemAddedData(Array.from(uniqueEntries));
    }, [props.ReportData]);
    
    return (
        <>
            <div className='IncomeReport-Grid' style={{ marginTop: "10px",margin:'0 auto' }}>
              <Grid item xs={12} sm={3}>
                <div>
                  <div>
                    <FrontDeskIncomeReportGridTable 
                      tableData={itemAddedData}
                      sendDataToParent={props.sendDataToParent} getReportData={props.getReportData}
                      getTotalDrillDownData={props.getTotalDrillDownData}
                      reqBody={props.reqBody} resData={props.resData}
                      sendDrillDownRequestBody={props.sendDrillDownRequestBody}
                    />
                  </div>
                </div>
              </Grid>
            </div>
        </>
    );
};

export default FrontDeskIncomeReportTableData;